import { ThemeConfig } from 'antd'
import { createGlobalStyle } from 'antd-style'

declare module 'antd-style' {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions, @typescript-eslint/no-empty-object-type
  interface FullToken extends ColorPalette {}
}

type ShadeKey = '1' | '2' | '3' | '4'

type ColorType = 'lightGrey' | 'grey' | 'black' | 'primary' | 'complimentary'

type ShadePalette<Color extends ColorType> = {
  [key in `${Color}${ShadeKey}`]: string
}

type ColorPalette = {
  lightGrey: ShadePalette<'lightGrey'>
  grey: ShadePalette<'grey'>
  black: ShadePalette<'black'>
  primary: ShadePalette<'primary'>
  complimentary: ShadePalette<'complimentary'>
}

export const theme: ThemeConfig = {
  token: {
    fontFamily: '"Sora", sans-serif',
    fontSize: 14,
    colorPrimary: '#3498DB',
    orange: '#FF5722',
    fontSizeHeading1: 56,
    fontSizeHeading2: 48,
    fontSizeHeading3: 40,
    fontSizeHeading4: 32,
    fontSizeHeading5: 24,
    colorText: '#000000'
  },
  components: {
    Layout: {
      footerBg: '#fff',
      bodyBg: '#f1f1f1',
      headerBg: '#fff',
      siderBg: '#fff',
      footerPadding: '16px 32px',
      headerPadding: '0px 24px',
      headerHeight: 60
    },
    Divider: {
      marginLG: 16,
      colorSplit: '#bcc5d4'
    },
    Avatar: {
      colorTextPlaceholder: '#00000040'
    },
    Menu: {
      itemMarginBlock: 8
    },
    Button: {
      colorLink: '#3498DB'
    },
    Table: {
      headerSortActiveBg: '#fafafa',
      bodySortBg: '#fff'
    },
    Card: {
      headerBg: '#F1F1F1'
    },
    Segmented: {
      itemColor: '#000000E0',
      trackBg: '#F0F0F0'
    }
  }
}

export const customToken = {
  lightGrey: {
    lightGrey1: '#f1f1f1',
    lightGrey2: '#f6f6f6',
    lightGrey3: '#f9f9f9'
  },
  grey: {
    grey1: '#818b9c',
    grey2: '#9ba6b9',
    grey3: '#bcc5d4'
  },
  black: {
    black1: '#0b0e0f',
    black2: '#1d2023',
    black3: '#313337'
  },
  primary: {
    primary1: '#3498db',
    primary2: '#5dade2',
    primary3: '#85c1e9'
  },
  complimentary: {
    complimentary1: '#E88A46',
    complimentary2: '#3AC79D',
    complimentary3: '#FF697B',
    complimentary4: '#7569FF'
  }
}

export const Global = createGlobalStyle`
* {
  scrollbar-width: thin;
  margin: 0px;
  padding: 0px;
}

.full-width {
  width: 100%;
}

.fit-content {
  width: fit-content;
}

.pointer {
  cursor: pointer;
}

.flex-1 {
  flex: 1;
}

.modal-title {
  font-size: 20px !important;
  font-weight: 700 !important;
  line-height: 28px;
}

form,
input,
select,
.ant-tabs-tab-btn,
.ant-breadcrumb-link,
.ant-select-selection-item,
.textarea,
.ant-tag {
  font-weight: 500 !important;
}

.ant-menu {
  font-weight: 500
}

.ant-typography {
  margin: 0 !important;
}

.ant-radio-wrapper {
  font-weight: 400
}

.ant-tabs .ant-tabs-nav::before {
  border-bottom: 2px solid #0000000F;
}

.ant-form-item {
  margin-bottom: 0;
}

.ant-divider {
  border-color: #0000000F;
}

.ant-collapse {
  border-color: #0000000F;
  background-color: transparent;
}

.ant-collapse .ant-collapse-item {
  border: none;
}

.ant-collapse .ant-collapse-item .ant-collapse-header {
  color: #000000E0;
  height: 64px;
  background-color: #F1F1F1;
  padding: 16px 24px;
  border-radius: 6px 6px 0 0;
  align-items: center;
}

.ant-collapse .ant-collapse-item .ant-collapse-content {
  border-top: none;
}

.ant-collapse .ant-collapse-item .ant-collapse-content .ant-collapse-content-box {
  padding: 0;
}

.ant-collapse .ant-collapse-item .ant-collapse-header .ant-collapse-arrow {
  font-size: 16px;
}

.ant-modal .ant-modal-title {
  font-size: 16px;
  padding: 16px 24px;
}

.ant-modal .ant-modal-content {
  padding: 0;
}

.ant-modal .ant-modal-close {
  top: 12px;
}

.ant-modal .ant-modal-header {
  border-bottom: 1px solid #F1F1F1;
}

.ant-modal .ant-modal-body {
  padding: 16px 24px;
}

.ant-modal .ant-modal-footer {
  padding-inline: 24px;
  padding-bottom: 16px;
}

.input-number-without-arrow {
  -moz-appearance: textfield;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
}

.ml-16 {
  margin-left: 16px !important;
}

.mt-16 {
  margin-top: 16px !important;
}
`
